// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetWidgetReservationsRequestModel from '../../model/get-widget-reservations-request-model';
import WidgetReservationListPagingResultModel from '../../model/widget-reservation-list-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getWidgetReservations(request: GetWidgetReservationsRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetReservationsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-reservations'] ?? 'WidgetReservations';
    const response = await service.post<any>(endpointPath, {
      body: {
        searchCriteria: requestDTO.searchCriteria,
        paging: requestDTO.paging,
        toccoFilter: requestDTO.toccoFilter,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(WidgetReservationListPagingResultModel.toModel(dto));
  },
});
